var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jds-rounded-full jds-font-bold jds-px-2 jds-text-sm jds-shadow-sm",class:_vm.classes},[_vm._v(" "+_vm._s(_vm.counter)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }